(() => {
  'use strict';

  const BANNER_SELECTOR = '.deco-carousel-container[data-deco-banner-id="3476"] .deco-banner-text';
  const NEW_TEXT = 'الطلبات قبل الساعه ٣ العصر توصل بنفس اليوم، و اذا بعد الساعه ٣ العصر توصل اليوم اللي بعده';

  const applyBannerText = (root = document) => {
    const scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll(BANNER_SELECTOR).forEach((element) => {
      if (element.textContent.trim() !== NEW_TEXT) {
        element.textContent = NEW_TEXT;
      }
    });
  };

  const applyFromNode = (node) => {
    if (!(node instanceof Element)) return;

    if (node.matches && node.matches(BANNER_SELECTOR)) {
      if (node.textContent.trim() !== NEW_TEXT) node.textContent = NEW_TEXT;
    }

    if (node.querySelectorAll) applyBannerText(node);
  };

  const start = () => {
    applyBannerText();

    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.type === 'characterData') {
          const parent = mutation.target.parentElement;
          const bannerText = parent && parent.closest ? parent.closest(BANNER_SELECTOR) : null;
          if (bannerText && bannerText.textContent.trim() !== NEW_TEXT) {
            bannerText.textContent = NEW_TEXT;
          }
          continue;
        }

        if (mutation.target instanceof Element) {
          const currentBannerText = mutation.target.closest && mutation.target.closest(BANNER_SELECTOR);
          if (currentBannerText && currentBannerText.textContent.trim() !== NEW_TEXT) {
            currentBannerText.textContent = NEW_TEXT;
          }
        }

        mutation.addedNodes.forEach(applyFromNode);
      }
    });

    observer.observe(document.documentElement, {
      subtree: true,
      childList: true,
      characterData: true,
    });

    /* Deco can rebuild or clone the carousel after its own app hydration. */
    [100, 250, 500, 1000, 2000, 4000, 8000].forEach((delay) => {
      window.setTimeout(applyBannerText, delay);
    });

    window.addEventListener('pageshow', applyBannerText);
    window.addEventListener('load', applyBannerText, { once: true });
    document.addEventListener('shopify:section:load', applyBannerText);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
